function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { positionalKeys } from '../../render/utils/keys-position.mjs';
import { findDimensionValueType } from '../../value/types/dimensions.mjs';
import { getVariableValue } from '../utils/css-variables-conversion.mjs';
import { isCSSVariableToken } from '../utils/is-css-variable.mjs';
import { KeyframeResolver } from './KeyframesResolver.mjs';
import { isNone } from './utils/is-none.mjs';
import { makeNoneKeyframesAnimatable } from './utils/make-none-animatable.mjs';
import { isNumOrPxType, positionalValues } from './utils/unit-conversion.mjs';

var DOMKeyframesResolver = /*#__PURE__*/function (_KeyframeResolver) {
  _inherits(DOMKeyframesResolver, _KeyframeResolver);

  var _super = _createSuper(DOMKeyframesResolver);

  function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
    _classCallCheck(this, DOMKeyframesResolver);

    return _super.call(this, unresolvedKeyframes, onComplete, name, motionValue, element, true);
  }

  _createClass(DOMKeyframesResolver, [{
    key: "readKeyframes",
    value: function readKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
          element = this.element,
          name = this.name;
      if (!element || !element.current) return;

      _get(_getPrototypeOf(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
      /**
       * If any keyframe is a CSS variable, we need to find its value by sampling the element
       */


      for (var i = 0; i < unresolvedKeyframes.length; i++) {
        var keyframe = unresolvedKeyframes[i];

        if (typeof keyframe === "string") {
          keyframe = keyframe.trim();

          if (isCSSVariableToken(keyframe)) {
            var resolved = getVariableValue(keyframe, element.current);

            if (resolved !== undefined) {
              unresolvedKeyframes[i] = resolved;
            }

            if (i === unresolvedKeyframes.length - 1) {
              this.finalKeyframe = keyframe;
            }
          }
        }
      }
      /**
       * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
       * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
       * have a far bigger performance impact.
       */


      this.resolveNoneKeyframes();
      /**
       * Check to see if unit type has changed. If so schedule jobs that will
       * temporarily set styles to the destination keyframes.
       * Skip if we have more than two keyframes or this isn't a positional value.
       * TODO: We can throw if there are multiple keyframes and the value type changes.
       */

      if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
        return;
      }

      var _unresolvedKeyframes = _slicedToArray(unresolvedKeyframes, 2),
          origin = _unresolvedKeyframes[0],
          target = _unresolvedKeyframes[1];

      var originType = findDimensionValueType(origin);
      var targetType = findDimensionValueType(target);
      /**
       * Either we don't recognise these value types or we can animate between them.
       */

      if (originType === targetType) return;
      /**
       * If both values are numbers or pixels, we can animate between them by
       * converting them to numbers.
       */

      if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
        for (var _i2 = 0; _i2 < unresolvedKeyframes.length; _i2++) {
          var value = unresolvedKeyframes[_i2];

          if (typeof value === "string") {
            unresolvedKeyframes[_i2] = parseFloat(value);
          }
        }
      } else if (positionalValues[name]) {
        /**
         * Else, the only way to resolve this is by measuring the element.
         */
        this.needsMeasurement = true;
      }
    }
  }, {
    key: "resolveNoneKeyframes",
    value: function resolveNoneKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
          name = this.name;
      var noneKeyframeIndexes = [];

      for (var i = 0; i < unresolvedKeyframes.length; i++) {
        if (unresolvedKeyframes[i] === null || isNone(unresolvedKeyframes[i])) {
          noneKeyframeIndexes.push(i);
        }
      }

      if (noneKeyframeIndexes.length) {
        makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
      }
    }
  }, {
    key: "measureInitialState",
    value: function measureInitialState() {
      var element = this.element,
          unresolvedKeyframes = this.unresolvedKeyframes,
          name = this.name;
      if (!element || !element.current) return;

      if (name === "height") {
        this.suspendedScrollY = window.pageYOffset;
      }

      this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
      unresolvedKeyframes[0] = this.measuredOrigin; // Set final key frame to measure after next render

      var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];

      if (measureKeyframe !== undefined) {
        element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
      }
    }
  }, {
    key: "measureEndState",
    value: function measureEndState() {
      var _this$removedTransfor;

      var element = this.element,
          name = this.name,
          unresolvedKeyframes = this.unresolvedKeyframes;
      if (!element || !element.current) return;
      var value = element.getValue(name);
      value && value.jump(this.measuredOrigin, false);
      var finalKeyframeIndex = unresolvedKeyframes.length - 1;
      var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
      unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));

      if (finalKeyframe !== null && this.finalKeyframe === undefined) {
        this.finalKeyframe = finalKeyframe;
      } // If we removed transform values, reapply them before the next render


      if ((_this$removedTransfor = this.removedTransforms) !== null && _this$removedTransfor !== void 0 && _this$removedTransfor.length) {
        this.removedTransforms.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              unsetTransformName = _ref2[0],
              unsetTransformValue = _ref2[1];

          element.getValue(unsetTransformName).set(unsetTransformValue);
        });
      }

      this.resolveNoneKeyframes();
    }
  }]);

  return DOMKeyframesResolver;
}(KeyframeResolver);

export { DOMKeyframesResolver };